package fr.arcplex.network.model

/**
 * A DRM-ready playback descriptor: what the player needs to start a stream.
 * UI-only data (artwork, synopsis, ...) stays in the screen model.
 */
data class PlaybackSource(
    val url: String,
    val licenceUrl: String,
    val payload: Map<String, String>,
    val provisionUrl: String? = null,
    val vudrmToken: String? = null
)
